<template>
  <div id="app">
    <google-map />
  </div>
</template>

<script>
import GoogleMap from "./components/GoogleMap";
import GmapCluster from 'vue2-google-maps/dist/components/cluster'

export default {
  name: "App",
  components: {
    GoogleMap,
    GmapCluster,
  }
};



</script>